const reasons = [
  {
    icon: 'ri-home-heart-line',
    title: 'Ev Taşıma Uzmanlığı',
    description: 'Türkiye\'nin 81 ilinden Avrupa\'nın 27 ülkesine anahtar teslim ev taşıma. Paketlemeden kuruluma, söküm ve montaja kadar her şey dahil.',
    stat: '50+',
    statLabel: 'Yıllık Deneyim',
  },
  {
    icon: 'ri-box-3-line',
    title: 'Parsiyel Taşımacılık',
    description: 'Küçük yükler için büyük çözüm. Sadece yüklediğiniz kadar ödeyin, haftalık düzenli seferlerle Avrupa\'nın istediğiniz ülkesine ulaşın.',
    stat: 'Haftalık',
    statLabel: 'Düzenli Sefer',
  },
  {
    icon: 'ri-truck-line',
    title: 'Kargo Taşımacılığı',
    description: 'Bireysel kargolardan ticari yüklere kadar her boyutta güvenli, hızlı ve sigortalı kargo hizmeti. Kapıdan kapıya teslimat garantisi.',
    stat: '5–8',
    statLabel: 'İş Günü Teslimat',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Sigortalı Taşımacılık',
    description: 'Tüm yükleriniz taşıma sürecinde sigorta güvencesi altındadır. Avrupa\'nın her noktasına hasar durumunda tam tazminat.',
    stat: '%100',
    statLabel: 'Sigorta Güvencesi',
  },
  {
    icon: 'ri-money-euro-circle-line',
    title: 'Şeffaf Fiyatlandırma',
    description: 'Gizli ücret yok. Fiyat teklifinizi peşinen öğrenin, ödeme teslimatta yapılabilir. 50 yıldır aynı dürüstlük.',
    stat: '0',
    statLabel: 'Gizli Ücret',
  },
  {
    icon: 'ri-global-line',
    title: '27 Ülke Ağı',
    description: 'Almanya\'daki depomuzdan tüm Avrupa\'ya dağıtım yapıyoruz. Fransa\'dan İspanya\'ya, Hollanda\'dan Polonya\'ya — her ülkeye güvenli teslimat.',
    stat: '27',
    statLabel: 'Avrupa Ülkesi',
  },
];

export default function WhyChooseUsSection() {
  return (
    <section id="why-us" className="py-20 md:py-28 bg-brand-cream">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="text-brand-orange font-semibold text-sm uppercase tracking-widest mb-3">Neden Töle Lojistik?</p>
          <h2 className="text-brand-navy font-heading font-bold text-3xl md:text-4xl mb-5">
            50 Yıllık Deneyim,
            <br />
            Aile Güvencesiyle Hizmet
          </h2>
          <p className="text-gray-400 text-base leading-relaxed">
            1975'ten bu yana baba-oğul ortaklığıyla büyüyen firmamız, ev taşıma, parsiyel ve kargo taşımacılığında sektörün en güvenilir ismi.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {reasons.map((reason) => (
            <div
              key={reason.title}
              className="bg-white rounded-2xl p-6 border border-gray-100 hover:border-brand-orange/20 transition-all duration-300 hover:-translate-y-1 group"
            >
              {/* Icon + Stat Row */}
              <div className="flex items-start justify-between mb-5">
                <div className="w-12 h-12 flex items-center justify-center bg-brand-orange/10 text-brand-orange rounded-xl group-hover:bg-brand-orange group-hover:text-white transition-all duration-300">
                  <i className={`${reason.icon} text-2xl`}></i>
                </div>
                <div className="text-right">
                  <div className="font-heading font-bold text-xl text-brand-navy">{reason.stat}</div>
                  <div className="text-xs text-gray-400">{reason.statLabel}</div>
                </div>
              </div>

              <h3 className="text-brand-navy font-heading font-bold text-base mb-2">{reason.title}</h3>
              <p className="text-gray-400 text-sm leading-relaxed">{reason.description}</p>
            </div>
          ))}
        </div>

        {/* Europe Coverage Banner */}
        <div className="mt-10 bg-white rounded-2xl p-6 border border-gray-100">
          <div className="flex flex-col md:flex-row items-center gap-6">
            <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-brand-orange/10 text-brand-orange rounded-xl">
              <i className="ri-map-2-line text-2xl"></i>
            </div>
            <div className="flex-1 text-center md:text-left">
              <h4 className="text-brand-navy font-heading font-bold text-base mb-1">Hizmet Verdiğimiz Ülkeler</h4>
              <p className="text-gray-400 text-sm leading-relaxed">
                Almanya · Fransa · Hollanda · Belçika · Avusturya · İsviçre · İtalya · İspanya · Portekiz · İsveç · Norveç · Danimarka · Finlandiya · Polonya · Çekya · Slovakya · Macaristan · Romanya · Bulgaristan · Yunanistan · Hırvatistan · Slovenya · Lüksemburg · İrlanda · ve daha fazlası...
              </p>
            </div>
            <div className="flex-shrink-0 text-center">
              <div className="text-brand-orange font-heading font-bold text-3xl">27+</div>
              <div className="text-gray-400 text-xs">Avrupa Ülkesi</div>
            </div>
          </div>
        </div>

        {/* Bottom CTA Banner */}
        <div className="mt-6 bg-brand-navy rounded-2xl p-8 md:p-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="text-white font-heading font-bold text-xl md:text-2xl mb-2">
              Hemen Fiyat Teklifi Alın
            </h3>
            <p className="text-white/60 text-sm">
              Boyut ve ağırlık bilgisi yeterli — 5 dakika içinde size dönüyoruz.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 flex-shrink-0">
            <a
              href="https://wa.me/905322376576?text=Merhaba%2C%20fiyat%20teklifi%20almak%20istiyorum."
              target="_blank"
              rel="nofollow noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-whatsapp hover:bg-whatsapp-dark text-white px-6 py-3 rounded-md text-sm font-semibold transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-whatsapp-line text-base"></i>
              </span>
              WhatsApp ile Sor
            </a>
            <a
              href="tel:+905322376576"
              className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 border border-white/20 text-white px-6 py-3 rounded-md text-sm font-semibold transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-line text-base"></i>
              </span>
              Hemen Ara
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
